import React, { useEffect, useState, useRef } from 'react'
import './SingleTravel.min.css'
import { AiFillDelete, AiFillEdit, AiOutlineClose } from 'react-icons/ai'
import axios from 'axios';
import { RiRoadMapLine } from 'react-icons/ri'
import { Travel } from '../TravelsPlanned/model'
import Swal from 'sweetalert2'
import { group } from 'console';
import { ipAddress } from '../../ipAddress';

interface Attraction {
  id: number;
  name: string;
  isDone: number;
  description: string;
}
interface Group {
  id: number;
  name: string;
}

interface Props {
  attractions: Attraction[];
  setAttractions: React.Dispatch<React.SetStateAction<Attraction[]>>;
  attraction: Attraction;
  travel: Travel;
  group: Group;
}


const AttractionsTravel: React.FC<Props> = ({ attractions, setAttractions, attraction, travel, group }) => {
  const [edit, setEdit] = useState<boolean>(false);
  const [editAttraction, setEditAttraction] = useState<string>(attraction.name);
  const [addOption, setAddOption] = useState<boolean>(false);
  const [openDescriptionAttraction, setOpenDescriptionAttraction] = useState<boolean>(false);
  const [descriptionAttraction, setDescriptionAttraction] = useState<string>(attraction.description);
  const [descriptionAttractionEdit, setDescriptionAttractionEdit] = useState<string>(attraction.description);
  const [editDescription, setEditDescription] = useState<boolean>(false);


  const handleChange = (id: number, isDone: number, city: string) => {
    if (isDone === 1) {
      isDone = 0
    } else {
      isDone = 1
    }
    axios.post(ipAddress + '/doneAttractionTravel', {
      id: id,
      isDone: isDone,
    })

    // setBaggages(baggages.map((baggage) => baggage.id == id ? {...baggage, isDone: 0}: baggage ))

  };





  const handleDelete = (id: number, name: string) => {
    Swal.fire({
      title: name,
      text: "Czy jesteś pewien, że chcesz usunąc ten element ?",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + '/deleteAttractionTravel', {
          id: id,
        })
        // setCosts(costs.filter((cost) => (cost.id !== id) ))
      }
    })

  }







  const handleEdit = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    setAddOption(false)
    axios.post(ipAddress + "/editAttraction", {
      attraction: editAttraction,
      id: id,

    })
      .then((response) => {
        /*  setTravels(travels.map((travel) => (
           travel.id === id ? {...travel, city:editCity , date: editDate } : travel
         ))) */
      })
      .catch(function (error) {
        console.log("error!")

      })

    setEdit(false)
  }

  const close = () => {
    setEdit(false);
    setEditAttraction(attraction.name);
  }



  const resize = () => {
    let element = document.getElementById("textAreaEditAttraction")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }


  const addDescriptionAttraction = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + '/addTravelDescriptionAttraction', {
      description: descriptionAttractionEdit,
      attractionId: id,
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setDescriptionAttraction('');
    setOpenDescriptionAttraction(false);


  }
  const inputRef4 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef4.current?.focus();

  }, [attraction])

  const updateTravelDescriptionAttraction = () => {
    axios.post(ipAddress + "/getTravelDescriptionAttraction", {
      attractionId: attraction.id,
    })
      .then((response) => {
        setDescriptionAttraction(response.data[0].description)

      }
      )
      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelDescriptionAttraction()
  }, [attractions])

  //console.log(attractions)

  const editDescriptionAttraction = (e: React.FormEvent, id: number) => {
    e.preventDefault();
    axios.post(ipAddress + '/editTravelDescriptionAttraction', {
      description: descriptionAttractionEdit,
      attractionId: id,
    })
      .then((response) => {
        // setBaggages([...baggages, { id: Math.random(), name: descriptionBaggages, isDone: 0 }])
      })
      .catch((err) => {
        console.log(err)
      })

    setEditDescription(false);


  }
  const inputRef5 = useRef<HTMLInputElement>(null)

  useEffect(() => {
    inputRef5.current?.focus();

  }, [attraction])


  const resize2 = () => {
    let element = document.getElementById("textAreaDescriptionAttraction")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }
  const resize3 = () => {
    let element = document.getElementById("textAreaDescriptionAttractionEdit")
    element.style.height = "5px";
    element.style.height = (element.scrollHeight) + "px";
  }

  let map = `https://maps.google.com/?q=${attraction.name},${travel.city}`

  return (

    <div className='listAttractions'>

      <div className='done'>

        {attraction.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true}
              onChange={() => handleChange(attraction.id, attraction.isDone, travel.city)}
            ></input>
            <s className='text'> {attraction.name} </s>

          </span>

        ) : (
          <span>
            <input type='checkbox' checked={false}
              onChange={() => handleChange(attraction.id, attraction.isDone, travel.city)}
            ></input>
            <div className='icons'>
              <span className='openMap' ><a href={map}><RiRoadMapLine /></a></span>
              <span className='edit' onClick={() => setEdit(true)} ><AiFillEdit /></span>
              <span className='delete' onClick={() => handleDelete(attraction.id, attraction.name)} ><AiFillDelete /></span>
            </div>
            <span className='text' onClick={() => setOpenDescriptionAttraction(true)}> {attraction.name}</span>

          </span>
        )
        }

      </div>

      {
        edit ? (
          <form className='editAttraction' onSubmit={(e) => { handleEdit(e, attraction.id) }}>
            <button type='button' id='close' onClick={() => close()} >X</button>
            <p>Edytuj miejsce do zwiedzania</p>
            <div className='thing'>
              <label htmlFor="thing">Co: </label>
              <textarea id='textAreaEditAttraction'
                rows={2}
                value={editAttraction}
                onChange={(e) => (resize(), setEditAttraction(e.target.value))}
                onClick={() => resize()}
              ></textarea>
            </div>

            <button type='submit' id='submit'>OK</button>
          </form>
        ) : (
          <span></span>
        )
      }


      {openDescriptionAttraction ? (
        <div>

          {descriptionAttraction.length === 0 ? (
            <div className='addDescriptionAttraction'>

              <form onSubmit={(e) => { addDescriptionAttraction(e, attraction.id) }}>
                <button type='button' id='close' onClick={() => setOpenDescriptionAttraction(false)} >X</button>
                <p id='city'>{group.name}</p>
                <p> Atrakcja: {attraction.name}</p>
                <div className='thingName'>

                  <textarea id='textAreaDescriptionAttraction'
                    rows={4}
                    placeholder='Opis atrakcji'
                    value={descriptionAttractionEdit}
                    onChange={(e) => (resize2(), setDescriptionAttractionEdit(e.target.value))}
                    required
                  ></textarea>
                </div>
                <button type='submit' id='submit'>OK</button>

              </form>
            </div>
          ) : (
            <div className='addDescriptionAttraction'>

              <form onSubmit={() => (setEditDescription(true), setOpenDescriptionAttraction(false))}>
                <button type='button' id='close' onClick={() => setOpenDescriptionAttraction(false)} >X</button>
                <p id='city'>{group.name} </p>
                <p> Atrakcja: {attraction.name}</p>
                <div className='thingName'>

                  <textarea id='textAreaDescriptionAttraction'
                    rows={20}
                    placeholder='Opis atrakcji'
                    value={descriptionAttractionEdit}
                    readOnly

                  ></textarea>
                </div>
                <button type='submit' id='submit'>Edit</button>

              </form>
            </div>



          )

          }

        </div>
      )
        :
        (<div>

        </div>)}
      {editDescription ?
        (
          <div className='addDescriptionAttraction'>

            <form onSubmit={(e) => { editDescriptionAttraction(e, attraction.id) }}>
              <button type='button' id='close' onClick={() => (setEditDescription(false), setDescriptionAttractionEdit(descriptionAttraction))} >X</button>
              <p id='city'>{group.name}</p>
              <p> Atrakcja: {attraction.name}</p>
              <div className='thingName'>

                <textarea id='textAreaDescriptionAttractionEdit'
                  rows={20}
                  placeholder='Opis atrakcji'
                  value={descriptionAttractionEdit}
                  onChange={(e) => (resize3(), setDescriptionAttractionEdit(e.target.value))}
                  required
                ></textarea>
              </div>
              <button type='submit' id='submit'>Zapisz</button>

            </form>
          </div>
        )
        :
        (<div></div>)
      }


    </div >



  )
}

export default AttractionsTravel